export const HOME_BANNER_UPLOAD_REQUEST = "HOME_BANNER_UPLOAD_REQUEST";
export const HOME_BANNER_UPLOAD_SUCCESS = "HOME_BANNER_UPLOAD_SUCCESS";
export const HOME_BANNER_UPLOAD_FAIL = "HOME_BANNER_UPLOAD_FAIL";

export const HOME_BANNER_FETCH_REQUEST = "HOME_BANNER_FETCH_REQUEST";
export const HOME_BANNER_FETCH_SUCCESS = "HOME_BANNER_FETCH_SUCCESS";
export const HOME_BANNER_FETCH_FAIL = "HOME_BANNER_FETCH_FAIL";

export const HOME_BANNER_DELETE_REQUEST = "HOME_BANNER_DELETE_REQUEST";
export const HOME_BANNER_DELETE_SUCCESS = "HOME_BANNER_DELETE_SUCCESS";
export const HOME_BANNER_DELETE_FAIL = "HOME_BANNER_DELETE_FAIL";
